import { TranslateService } from '@ngx-translate/core';
import { FermeService } from './../services/ferme.service';
import { NbMenuService, NbMenuItem } from '@nebular/theme';
import { Component } from '@angular/core';
import { MENU_ITEMS } from './pages-menu';
import { takeWhile } from 'rxjs/operators';
import { NbAccessChecker } from '@nebular/security';
import { UserIdleService } from 'angular-user-idle';
import { Router } from '@angular/router';
@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-sample-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-sample-layout>
  `,
})
export class PagesComponent {

  menu = MENU_ITEMS;
  private alive: boolean = true;
  selectedItem: string;
  
  constructor (private translate: TranslateService, private menuService: NbMenuService, private accessChecker: NbAccessChecker,private userIdle: UserIdleService,private router: Router) {
    
  }
  getSelectedItem() {
    this.menuService.getSelectedItem('menu')
      .pipe(takeWhile(() => this.alive))
      .subscribe( (menuBag) => {
        console.log('menubag fin');
        console.log(menuBag);
        console.log('menubag fin');
        this.selectedItem = menuBag.item.title;
      });
  }

  ngOnInit() {
    this.authMenuItems();

    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count =>{
      var eventList= ["click", "mouseover","keydown","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","scroll","keyup"];
        for(let event of eventList) {
          document.body.addEventListener(event, () =>this.restart());
        }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.stopWatching();
      this.router.navigate(['auth/logout']);
    });
  }

  stop() {
    this.userIdle.stopTimer();
  }
 
  stopWatching() {
    this.userIdle.stopWatching();
  }
 
  startWatching() {
    this.userIdle.startWatching();
  }
 
  restart() {
    this.userIdle.resetTimer();
  }

  authMenuItems() {
    this.menu.forEach(item => {
      this.translate.get(item.title).subscribe((res: string) => {
        item.title = res;
        this.authMenuItem(item);
        if (item.children) {
          item.children.forEach(child => {
            this.translate.get(child.title).subscribe((res2: string) => {
              child.title = res2;
            });
          });
        }
      });
    });
  }

  authMenuItem(menuItem: NbMenuItem) {
    if (menuItem.data && menuItem.data['permission'] && menuItem.data['resource']) {
      this.accessChecker.isGranted(menuItem.data['permission'], menuItem.data['resource']).subscribe(granted => {
        menuItem.hidden = !granted;
      });
    } else {
      menuItem.hidden = true;
    }
    if (!menuItem.hidden && menuItem.children != null) {
      menuItem.children.forEach(item => {
        if (item.data && item.data['permission'] && item.data['resource']) {
          this.accessChecker.isGranted(item.data['permission'], item.data['resource']).subscribe(granted => {
            item.hidden = !granted;
          });
        } else {
          // if child item do not config any `data.permission` and `data.resource` just inherit parent item's config
          item.hidden = menuItem.hidden;
        }
      });
    }
  }
}